/**
 * city/textures/city-textures.js
Hệ thống Procedural Canvas Textures cho Đô Thị Việt Nam
 */

import * as THREE from 'three';
import { createCanvas } from '../../core/canvas-texture.js';
import { registerTextureSurfacesMethods } from './textures-surfaces.js';
import { registerTextureInteriorSignsMethods } from './textures-interior-signs.js';
import { registerTextureStreetMethods } from './textures-street.js';

class MethodsHolder {
  createProceduralCanvasTexture(width, height, drawFn) {
    const canvas = createCanvas(width, height);
    const ctx = canvas.getContext('2d');
    drawFn(ctx, width, height);
    const texture = new THREE.CanvasTexture(canvas);
    texture.colorSpace = THREE.SRGBColorSpace;
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.anisotropy = 8;
    this.disposables.push(texture);
    return texture;
  }

  _tex(key, w, h, drawFn) {
    let t = this._texCache.get(key);
    if (!t) {
      t = this.createProceduralCanvasTexture(w, h, drawFn);
      this._texCache.set(key, t);
    }
    return t;
  }

  // Bản sao texture với hệ số lặp riêng (dùng chung ảnh nguồn)
  _repeat(texture, rx, ry) {
    const t = texture.clone();
    t.repeat.set(rx, ry);
    t.needsUpdate = true;
    this.disposables.push(t);
    return t;
  }
}

export function registerTextureMethods(proto) {
  registerTextureSurfacesMethods(proto);
  registerTextureInteriorSignsMethods(proto);
  registerTextureStreetMethods(proto);

  Object.getOwnPropertyNames(MethodsHolder.prototype).forEach((name) => {
    if (name !== 'constructor') {
      proto[name] = MethodsHolder.prototype[name];
    }
  });
}
